import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Formik
import { useFormikContext } from 'formik';
// Elements
import Label from '../elements/Label';
import Error from '../elements/Error';
import useFormDuuf from '../useFormDuuf';
const ConsentField = ({ formik = {}, hasError = false, fieldId, data }) => {
  const { privacyUrl, privacyUrlPlacement } = useFormDuuf();
  const { handleChange, handleBlur, values } = useFormikContext();
  const type = data.type.toLowerCase();
  return _jsxs("div", { className: `form-duuf-group form-duuf-group-${type}${data.cssClass ? ` ${data.cssClass}` : ''}`, children: [_jsx(Label, { fieldId: fieldId, data: data }), _jsx(Error, { fieldId: fieldId, data: data, hasError: hasError, formik: formik }), _jsxs("div", { className: "d-flex align-items-center flex items-center", children: [_jsx("input", { type: "checkbox", className: `form-duuf-checkbox form-duuf-checkbox-${type}`, id: fieldId, name: fieldId, placeholder: data.placeholder, onBlur: handleBlur, onChange: (event) => {
          handleChange({
            target: {
              name: event.target.name,
              value: !values[fieldId]
            }
          });
        }, value: values[fieldId], checked: values[fieldId] }), privacyUrl && _jsx("span", { dangerouslySetInnerHTML: {
          __html: `${data.checkboxLabel.replace(privacyUrlPlacement ? privacyUrlPlacement : data.checkboxLabel, `<a
                target="_blank"
                rel="noreferrer noopener"
                href="${privacyUrl}"
                class="form-duuf-checkbox-label form-duuf-checkbox-${type}"
              >${privacyUrlPlacement ? privacyUrlPlacement : data.checkboxLabel}</a>`)}`
        } }), !privacyUrl && _jsx("label", { htmlFor: fieldId, className: `form-duuf-checkbox-label form-duuf-checkbox-${data.type}`, children: data.checkboxLabel })] })] });
};
export default ConsentField;